export default __webpack_public_path__ + "static/media/unevenComplexionActive.2af1057c.svg";